import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../../app/directives/shared.module'
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { c_card_scheduled_arming_component } from './c_card_scheduled_arming.component';
import { DraggableScheduleDirective } from './draggable.directive';
import { SiteArmSchduleModule } from '@app/modals/site/site-arm-schedule/site-arm-schedule.module';
import { SiteArmEditModule } from '@app/modals/site-arm-edit/site-arm-edit.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    MatSlideToggleModule,
    SiteArmSchduleModule,
    SiteArmEditModule
  ],
  declarations: [ c_card_scheduled_arming_component, DraggableScheduleDirective],
  exports: [c_card_scheduled_arming_component],
})
export class c_card_scheduled_arming_module { }
